// Angular
import { Injectable } from '@angular/core';

// Interfaces
import { IIncidentResponse, INewIncidentResponse, IUpdatedIncidentResponse } from '../../interfaces/seacom/incidentresponse';

// Services
import { ApiNodeService } from './templates/apinode.service';
import { SeacomApiService } from './seacom-api.service';


@Injectable({
  providedIn: 'root'
})
export class IncidentResponsesService extends ApiNodeService<IIncidentResponse, INewIncidentResponse, IUpdatedIncidentResponse> {
  node = 'incidentresponses';

  constructor(public seacomApiService: SeacomApiService) {
    super(seacomApiService);
  }
}
